import { render, staticRenderFns } from "./HUD.vue?vue&type=template&id=1b5ced70&"
import script from "./HUD.vue?vue&type=script&lang=js&"
export * from "./HUD.vue?vue&type=script&lang=js&"
import style0 from "./HUD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports